const FormStyleKeys = {
  FONT_FAMILY: 'fontFamily',
  BACKGROUND_WIDTH: 'backgroundWidth',
  BACKGROUND_COLOR: 'backgroundColor',
  BORDER_RADIUS: 'borderRadius',
  PADDING: 'padding',
  LABEL_TEXT_COLOR: 'labelTextColor',
  LABEL_TEXT_SIZE: 'labelTextSize',
  HELP_TEXT_COLOR: 'helpTextColor',
  HELP_TEXT_SIZE: 'helpTextSize',
  LINK_COLOR: 'linkColor',
  CLICKED_LINK_COLOR: 'clickedLinkColor',
  LEGAL_CONSENT_TEXT_COLOR: 'legalConsentTextColor',
  LEGAL_CONSENT_TEXT_SIZE: 'legalConsentTextSize',
  THANK_YOU_TEXT_COLOR: 'thankYouTextColor',
  THANK_YOU_TEXT_SIZE: 'thankYouTextSize',
  SUBMIT_COLOR: 'submitColor',
  SUBMIT_ALIGNMENT: 'submitAlignment',
  SUBMIT_FONT_COLOR: 'submitFontColor',
  SUBMIT_SIZE: 'submitSize',
  PAGINATION_PROGRESS_COLOR: 'paginationProgressColor',
  PAGINATION_PROGRESS_TEXT_COLOR: 'paginationProgressTextColor',
  PAGINATION_PROGRESS_SHOW: 'paginationProgressShow',
  PAGINATION_PROGRESS_TRANSITION: 'paginationProgressTransition',
  PAGINATION_PROGRESS_THEME: 'paginationProgressTheme',
  PAGINATION_CONTENT_USE_SCROLL: 'paginationContentUseScroll',
  PAGINATION_CONTENT_SCROLL_HEIGHT: 'paginationContentScrollHeight'
};
export default FormStyleKeys;